/**
 * Bản tiếng Anh của dải logo. Mỗi chuỗi lấy từ thuộc tính `data-en` của CHÍNH node đó trong
 * `template.html` — không dịch mới.
 */
export const socialProof = {
  eyebrow: 'Currently in pilot with three enterprise customers',
  logos: ['Customer logo 01', 'Customer logo 02', 'Customer logo 03'],
  note: 'Names to be confirmed with the customers.',
};
